import DuckEntity from './DuckEntity';
import { apiFetch } from '../utils';
import { reviews } from './index';

const duck = new DuckEntity('reviews');

const commentFields = ['activities_comment', 'scores_comment', 'test_scores_comment'];

const checkCommentRef = (commentRef) => {
  const { field, checklistItemId } = commentRef;
  if (field && commentFields.indexOf(field) === -1) {
    throw `commentRef has invalid field '${field}'`;
  } else if (!field && !checklistItemId) {
    throw 'commentRef must specify field or checklistItemId';
  }
  return commentRef;
}

/**
 * Returns comment text for a given comment reference.
 *
 * @param {object} review review object
 * @param {object} commentRef identifies comment to get
 * @param {string} commentRef.field comment field name or null for checklist item comment
 * @param {string} commentRef.checklistItemId specifies checklist item
 * @return {string|null} comment text
 */
const getComment = (review, commentRef) => {
  const { field, checklistItemId } = checkCommentRef(commentRef);

  if (checklistItemId) {
    const comment = review.review_comments.find(c => c.checklist_item_id === checklistItemId);
    return comment ? comment.comment : null;
  } else {
    return review[field];
  }
};

/**
 * Updates review comment for a given comment reference.
 *
 * @param {object} review review object
 * @param {string} commentText new comment text
 * @param {object} commentRef identifies comment to get
 * @param {string} commentRef.field comment field name or null for checklist item comment
 * @param {string} commentRef.checklistItemId specifies checklist item
 * @return {(function(*): *)|*} action creator
 */
const updateComment = (review, commentText, commentRef) => {
  const { field, checklistItemId } = checkCommentRef(commentRef);

  if (checklistItemId) {
    return (dispatch) => apiFetch.put(
      {},
      `reviews/${review.id}/comment/${checklistItemId}`,
      { review_comment: { comment: commentText } }
    ).then(({ review_comment }) => {
      return dispatch(duck.actions.cacheSingle({
        ...review,
        review_comments: [
          ...review.review_comments.filter(c => c.checklist_item_id !== checklistItemId),
          review_comment
        ]
      }));
    });
  } else {
    return duck.actions.update({ id: review.id, [field]: commentText });
  }
};

const reducer = duck.reducer;

const entity = {
  ...duck,
  getComment,
  actions: {
    ...duck.actions,
    updateComment
  }
};

export { reducer as default, entity };
